// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/integration/external_ticketing/jira/v1/jira.proto" (package "c1.api.external_ticketing.jira.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
// For the get requests, I'm basing the parameters on what we actually use on the support dashboard

/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.Installations
 */
export interface Installations {
    /**
     * @generated from protobuf field: string installation_id = 1;
     */
    installationId: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetInstallationsRequest
 */
export interface GetInstallationsRequest {
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetInstallationsResponse
 */
export interface GetInstallationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Installations installations = 1;
     */
    installations: Installations[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetProjectsRequest
 */
export interface GetProjectsRequest {
    /**
     * @generated from protobuf field: string installation_id = 1;
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetProjectsResponse
 */
export interface GetProjectsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Project projects = 1;
     */
    projects: Project[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetCustomAppFieldsRequest
 */
export interface GetCustomAppFieldsRequest {
    /**
     * @generated from protobuf field: string installation_id = 1;
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetCustomAppFieldsResponse
 */
export interface GetCustomAppFieldsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Field fields = 1;
     */
    fields: Field[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetFieldsRequest
 */
export interface GetFieldsRequest {
    /**
     * @generated from protobuf field: string installation_id = 1;
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetFieldsResponse
 */
export interface GetFieldsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Field fields = 1;
     */
    fields: Field[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetTextFieldsRequest
 */
export interface GetTextFieldsRequest {
    /**
     * @generated from protobuf field: string installation_id = 1;
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetTextFieldsResponse
 */
export interface GetTextFieldsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Field fields = 1;
     */
    fields: Field[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetStatusesRequest
 */
export interface GetStatusesRequest {
    /**
     * @generated from protobuf field: string installation_id = 1;
     */
    installationId: string;
    /**
     * @generated from protobuf field: string project_id = 2;
     */
    projectId: string;
    /**
     * @generated from protobuf field: string category = 3;
     */
    category: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetStatusesResponse
 */
export interface GetStatusesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.JiraStatus statuses = 1;
     */
    statuses: JiraStatus[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetResolutionsRequest
 */
export interface GetResolutionsRequest {
    /**
     * @generated from protobuf field: string installation_id = 1;
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetResolutionsResponse
 */
export interface GetResolutionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.ResolutionState resolutions = 1;
     */
    resolutions: ResolutionState[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetRequestTypesRequest
 */
export interface GetRequestTypesRequest {
    /**
     * @generated from protobuf field: string installation_id = 1;
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetRequestTypesResponse
 */
export interface GetRequestTypesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.ServiceDeskRequestType request_types = 1;
     */
    requestTypes: ServiceDeskRequestType[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetAllOptionsFromJiraApiRequest
 */
export interface GetAllOptionsFromJiraApiRequest {
    /**
     * @generated from protobuf field: string installation_id = 1;
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetAllOptionsFromJiraApiResponse
 */
export interface GetAllOptionsFromJiraApiResponse {
    /**
     * @generated from protobuf field: string installation_id = 1;
     */
    installationId: string;
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Project projects = 2;
     */
    projects: Project[];
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Field fields = 3;
     */
    fields: Field[];
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Field text_fields = 4;
     */
    textFields: Field[];
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Field custom_app_fields = 5;
     */
    customAppFields: Field[];
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.ResolutionState resolutions = 6;
     */
    resolutions: ResolutionState[];
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.ServiceDeskRequestType request_types = 7;
     */
    requestTypes: ServiceDeskRequestType[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.BindJiraRequest
 */
export interface BindJiraRequest {
    /**
     * @generated from protobuf field: string base_url = 1;
     */
    baseUrl: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string integration_ref_id = 3;
     */
    integrationRefId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.BindJiraResponse
 */
export interface BindJiraResponse {
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.JiraConfig
 */
export interface JiraConfig {
    /**
     * @generated from protobuf field: string project_id = 1;
     */
    projectId: string;
    /**
     * @generated from protobuf field: string user_field_id = 2;
     */
    userFieldId: string;
    /**
     * @generated from protobuf field: bool c1_label_filter = 3;
     */
    c1LabelFilter: boolean;
    /**
     * @generated from protobuf field: string app_field_id = 4;
     */
    appFieldId: string;
    /**
     * @generated from protobuf field: string resource_field_id = 5;
     */
    resourceFieldId: string;
    /**
     * Labels don't have an id, just its name
     *
     * @generated from protobuf field: string requires_it_admin_label = 6;
     */
    requiresItAdminLabel: string;
    /**
     * The resolution status id for what is considered resolved
     *
     * @generated from protobuf field: string status_id = 7;
     */
    statusId: string;
    /**
     * The resolution state id for service desk's finer grained resolution states (Done, Wont Do, etc.)
     *
     * @generated from protobuf field: string cancelled_resolution_id = 8;
     */
    cancelledResolutionId: string;
    /**
     * @generated from protobuf field: string denied_resolution_id = 9;
     */
    deniedResolutionId: string;
    /**
     * @generated from protobuf field: string granted_resolution_id = 10;
     */
    grantedResolutionId: string;
    /**
     * @generated from protobuf field: string manual_provision_errored_resolution_id = 11;
     */
    manualProvisionErroredResolutionId: string;
    /**
     * @generated from protobuf field: string request_type_id = 12;
     */
    requestTypeId: string;
    /**
     * @generated from protobuf field: bool comments_internal = 13;
     */
    commentsInternal: boolean;
    /**
     * @generated from protobuf field: bool auto_submit = 14;
     */
    autoSubmit: boolean;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.Project
 */
export interface Project {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.Field
 */
export interface Field {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.ResolutionState
 */
export interface ResolutionState {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: bool is_default = 4;
     */
    isDefault: boolean;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.JiraStatus
 */
export interface JiraStatus {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string status_category = 4;
     */
    statusCategory: string;
    /**
     * @generated from protobuf field: c1.api.external_ticketing.jira.v1.Scope scope = 5;
     */
    scope?: Scope;
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Usage usages = 6;
     */
    usages: Usage[];
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.WorkflowUsage workflow_usages = 7;
     */
    workflowUsages: WorkflowUsage[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.Scope
 */
export interface Scope {
    /**
     * @generated from protobuf field: c1.api.external_ticketing.jira.v1.ProjectId project = 1;
     */
    project?: ProjectId;
    /**
     * @generated from protobuf field: string type = 2;
     */
    type: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.Usage
 */
export interface Usage {
    /**
     * @generated from protobuf field: repeated string issue_types = 1;
     */
    issueTypes: string[];
    /**
     * @generated from protobuf field: c1.api.external_ticketing.jira.v1.ProjectId project = 2;
     */
    project?: ProjectId;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.ProjectId
 */
export interface ProjectId {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.WorkflowUsage
 */
export interface WorkflowUsage {
    /**
     * @generated from protobuf field: string workflow_id = 1;
     */
    workflowId: string;
    /**
     * @generated from protobuf field: string workflow_name = 2;
     */
    workflowName: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.ServiceDeskRequestType
 */
export interface ServiceDeskRequestType {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string help_text = 4;
     */
    helpText: string;
    /**
     * @generated from protobuf field: string issue_type_id = 5;
     */
    issueTypeId: string;
    /**
     * @generated from protobuf field: string service_desk_id = 6;
     */
    serviceDeskId: string;
    /**
     * @generated from protobuf field: string portal_id = 7;
     */
    portalId: string;
    /**
     * @generated from protobuf field: repeated string group_ids = 8;
     */
    groupIds: string[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.ServiceDeskIssueRequest
 */
export interface ServiceDeskIssueRequest {
    /**
     * @generated from protobuf field: string issue_id = 1;
     */
    issueId: string;
    /**
     * @generated from protobuf field: string issue_key = 2;
     */
    issueKey: string;
    /**
     * @generated from protobuf field: string request_type_id = 3;
     */
    requestTypeId: string;
    /**
     * @generated from protobuf field: string service_desk_id = 4;
     */
    serviceDeskId: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Installations$Type extends MessageType<Installations> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.Installations", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.Installations
 */
export const Installations = new Installations$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInstallationsRequest$Type extends MessageType<GetInstallationsRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetInstallationsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetInstallationsRequest
 */
export const GetInstallationsRequest = new GetInstallationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInstallationsResponse$Type extends MessageType<GetInstallationsResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetInstallationsResponse", [
            { no: 1, name: "installations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Installations }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetInstallationsResponse
 */
export const GetInstallationsResponse = new GetInstallationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProjectsRequest$Type extends MessageType<GetProjectsRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetProjectsRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetProjectsRequest
 */
export const GetProjectsRequest = new GetProjectsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProjectsResponse$Type extends MessageType<GetProjectsResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetProjectsResponse", [
            { no: 1, name: "projects", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Project }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetProjectsResponse
 */
export const GetProjectsResponse = new GetProjectsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomAppFieldsRequest$Type extends MessageType<GetCustomAppFieldsRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetCustomAppFieldsRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetCustomAppFieldsRequest
 */
export const GetCustomAppFieldsRequest = new GetCustomAppFieldsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomAppFieldsResponse$Type extends MessageType<GetCustomAppFieldsResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetCustomAppFieldsResponse", [
            { no: 1, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetCustomAppFieldsResponse
 */
export const GetCustomAppFieldsResponse = new GetCustomAppFieldsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFieldsRequest$Type extends MessageType<GetFieldsRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetFieldsRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetFieldsRequest
 */
export const GetFieldsRequest = new GetFieldsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFieldsResponse$Type extends MessageType<GetFieldsResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetFieldsResponse", [
            { no: 1, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetFieldsResponse
 */
export const GetFieldsResponse = new GetFieldsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTextFieldsRequest$Type extends MessageType<GetTextFieldsRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetTextFieldsRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetTextFieldsRequest
 */
export const GetTextFieldsRequest = new GetTextFieldsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTextFieldsResponse$Type extends MessageType<GetTextFieldsResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetTextFieldsResponse", [
            { no: 1, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetTextFieldsResponse
 */
export const GetTextFieldsResponse = new GetTextFieldsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatusesRequest$Type extends MessageType<GetStatusesRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetStatusesRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "project_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetStatusesRequest
 */
export const GetStatusesRequest = new GetStatusesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatusesResponse$Type extends MessageType<GetStatusesResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetStatusesResponse", [
            { no: 1, name: "statuses", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JiraStatus }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetStatusesResponse
 */
export const GetStatusesResponse = new GetStatusesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetResolutionsRequest$Type extends MessageType<GetResolutionsRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetResolutionsRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetResolutionsRequest
 */
export const GetResolutionsRequest = new GetResolutionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetResolutionsResponse$Type extends MessageType<GetResolutionsResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetResolutionsResponse", [
            { no: 1, name: "resolutions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResolutionState }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetResolutionsResponse
 */
export const GetResolutionsResponse = new GetResolutionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRequestTypesRequest$Type extends MessageType<GetRequestTypesRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetRequestTypesRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetRequestTypesRequest
 */
export const GetRequestTypesRequest = new GetRequestTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRequestTypesResponse$Type extends MessageType<GetRequestTypesResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetRequestTypesResponse", [
            { no: 1, name: "request_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServiceDeskRequestType }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetRequestTypesResponse
 */
export const GetRequestTypesResponse = new GetRequestTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllOptionsFromJiraApiRequest$Type extends MessageType<GetAllOptionsFromJiraApiRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetAllOptionsFromJiraApiRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetAllOptionsFromJiraApiRequest
 */
export const GetAllOptionsFromJiraApiRequest = new GetAllOptionsFromJiraApiRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllOptionsFromJiraApiResponse$Type extends MessageType<GetAllOptionsFromJiraApiResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetAllOptionsFromJiraApiResponse", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "projects", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Project },
            { no: 3, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field },
            { no: 4, name: "text_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field },
            { no: 5, name: "custom_app_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field },
            { no: 6, name: "resolutions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResolutionState },
            { no: 7, name: "request_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServiceDeskRequestType }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetAllOptionsFromJiraApiResponse
 */
export const GetAllOptionsFromJiraApiResponse = new GetAllOptionsFromJiraApiResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BindJiraRequest$Type extends MessageType<BindJiraRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.BindJiraRequest", [
            { no: 1, name: "base_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { uri: true } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "integration_ref_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.BindJiraRequest
 */
export const BindJiraRequest = new BindJiraRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BindJiraResponse$Type extends MessageType<BindJiraResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.BindJiraResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.BindJiraResponse
 */
export const BindJiraResponse = new BindJiraResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JiraConfig$Type extends MessageType<JiraConfig> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.JiraConfig", [
            { no: 1, name: "project_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_field_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "c1_label_filter", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "app_field_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "resource_field_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "requires_it_admin_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "status_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "cancelled_resolution_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "denied_resolution_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "granted_resolution_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "manual_provision_errored_resolution_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "request_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "comments_internal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "auto_submit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.JiraConfig
 */
export const JiraConfig = new JiraConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Project$Type extends MessageType<Project> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.Project", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.Project
 */
export const Project = new Project$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Field$Type extends MessageType<Field> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.Field", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.Field
 */
export const Field = new Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolutionState$Type extends MessageType<ResolutionState> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.ResolutionState", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.ResolutionState
 */
export const ResolutionState = new ResolutionState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JiraStatus$Type extends MessageType<JiraStatus> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.JiraStatus", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status_category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "scope", kind: "message", T: () => Scope },
            { no: 6, name: "usages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Usage },
            { no: 7, name: "workflow_usages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WorkflowUsage }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.JiraStatus
 */
export const JiraStatus = new JiraStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Scope$Type extends MessageType<Scope> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.Scope", [
            { no: 1, name: "project", kind: "message", T: () => ProjectId },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.Scope
 */
export const Scope = new Scope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Usage$Type extends MessageType<Usage> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.Usage", [
            { no: 1, name: "issue_types", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "project", kind: "message", T: () => ProjectId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.Usage
 */
export const Usage = new Usage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectId$Type extends MessageType<ProjectId> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.ProjectId", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.ProjectId
 */
export const ProjectId = new ProjectId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkflowUsage$Type extends MessageType<WorkflowUsage> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.WorkflowUsage", [
            { no: 1, name: "workflow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "workflow_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.WorkflowUsage
 */
export const WorkflowUsage = new WorkflowUsage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceDeskRequestType$Type extends MessageType<ServiceDeskRequestType> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.ServiceDeskRequestType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "help_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "issue_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "service_desk_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "portal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "group_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.ServiceDeskRequestType
 */
export const ServiceDeskRequestType = new ServiceDeskRequestType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceDeskIssueRequest$Type extends MessageType<ServiceDeskIssueRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.ServiceDeskIssueRequest", [
            { no: 1, name: "issue_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "issue_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "request_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "service_desk_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.ServiceDeskIssueRequest
 */
export const ServiceDeskIssueRequest = new ServiceDeskIssueRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.external_ticketing.jira.v1.JiraService
 */
export const JiraService = new ServiceType("c1.api.external_ticketing.jira.v1.JiraService", [
    { name: "GetProjects", options: { "authz.method": { role: "VIEWER" } }, I: GetProjectsRequest, O: GetProjectsResponse },
    { name: "GetCustomAppFields", options: { "authz.method": { role: "VIEWER" } }, I: GetCustomAppFieldsRequest, O: GetCustomAppFieldsResponse },
    { name: "GetFields", options: { "authz.method": { role: "VIEWER" } }, I: GetFieldsRequest, O: GetFieldsResponse },
    { name: "GetTextFields", options: { "authz.method": { role: "VIEWER" } }, I: GetTextFieldsRequest, O: GetTextFieldsResponse },
    { name: "GetStatuses", options: { "authz.method": { role: "VIEWER" } }, I: GetStatusesRequest, O: GetStatusesResponse },
    { name: "GetResolutions", options: { "authz.method": { role: "VIEWER" } }, I: GetResolutionsRequest, O: GetResolutionsResponse },
    { name: "GetRequestTypes", options: { "authz.method": { role: "VIEWER" } }, I: GetRequestTypesRequest, O: GetRequestTypesResponse },
    { name: "GetAllOptionsFromJiraApi", options: { "authz.method": { role: "VIEWER" } }, I: GetAllOptionsFromJiraApiRequest, O: GetAllOptionsFromJiraApiResponse },
    { name: "BindJira", options: { "authz.method": { role: "EDITOR" } }, I: BindJiraRequest, O: BindJiraResponse }
]);
